export default function UnitSelect({ locale, id, label, units, value, onChange }) {
  const groupedUnits = Object.groupBy
    ? Object.groupBy(units, (unit) => unit.system)
    : units.reduce((groups, unit) => ({ ...groups, [unit.system]: [...(groups[unit.system] ?? []), unit] }), {})

  const systemLabels = locale === 'bg'
    ? { metric: 'Метрична / SI', imperial: 'Имперска / US', scientific: 'Научна', historical: 'Исторически български' }
    : locale === 'de'
      ? { metric: 'Metrisch / SI', imperial: 'Imperial / US', scientific: 'Wissenschaftlich', historical: 'Historisch bulgarisch' }
      : { metric: 'Metric / SI', imperial: 'Imperial / US', scientific: 'Scientific', historical: 'Historical Bulgarian' }

  return (
    <label className="field-label" htmlFor={id}>
      <span>{label}</span>
      <select id={id} value={value} onChange={(event) => onChange(event.target.value)}>
        {Object.entries(groupedUnits).map(([system, systemUnits]) => (
          <optgroup label={systemLabels[system] ?? system} key={system}>
            {systemUnits.map((unit) => (
              <option key={unit.id} value={unit.id}>
                {unit.name} ({unit.symbol}){unit.ancient ? ' · his' : ''}
              </option>
            ))}
          </optgroup>
        ))}
      </select>
    </label>
  )
}
